<template>
  <div class="-ai-reedit-container">
    <div class="-ai-reedit-container-inner">
      <template v-if="hasAiFeatures && timelineDuration > 0">
        <wt-button
          @click="clickCreateAiStory"
          class="-ai-button"
          :text="'Edit with AI'"
          v-tooltip.extend="tooltipOptions"
          :disabled="isDisabled"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import wtMakeNewWochit from 'components/modals/types/wtMakeNewWochit.component.vue';

export default {
  name: 'wt-edit-with-ai-button',

  computed: {
    ...mapState({
      timelineDuration: (state) => state.story.timelineDuration,
    }),
    ...mapGetters([
      'hasUploadingAssets',
      'lightboxAssetUUIDs',
      'hasVoiceOverAssets',
    ]),

    hasAiFeatures() {
      return (
        tk.context.organization.premiumFeatures &&
        tk.context.organization.premiumFeatures.includes('AI_PROMPT')
      );
    },

    isDisabled() {
      return this.hasUploadingAssets;
    },

    tooltipTitle() {
      return this.hasUploadingAssets
        ? 'Please wait for all uploads to finish'
        : '';
    },

    tooltipOptions() {
      return {
        title: this.tooltipTitle,
        trigger: 'hover',
        placement: 'bottom',
        delay: 100,
        wrapperClass: '-ai-redit-tooltip',
        container: '.-ai-reedit-container',
      };
    },
  },

  methods: {
    clickCreateAiStory() {
      app.showModal({
        type: 'custom scrollable',
        component: wtMakeNewWochit,
        componentPropsData: {
          existingStoryParams: {
            storyId: this.$store.state.story.id,
            programmerId: this.$store.state.story.programmerId,
            brandId: this.$store.state.story.brandId,
            themeId: this.$store.state.story.themeInfo.themeId,
            regenerateStory: true,
            assetUUIDs: this.lightboxAssetUUIDs.imageVideoUUIDs || [],
            hasOtherAssetsInLightbox: this.lightboxAssetUUIDs.hasOtherAssets,
            aspectRatio: this.$store.state.story.themeInfo.aspectRatio,
            hasVoiceOverAssets: this.hasVoiceOverAssets,
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.-ai-reedit-container {
  padding-left: 15px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-grow: 1;

  .-ai-reedit-container-inner {
    position: relative;
  }

  /deep/.-ai-button {
    // background: transparent;
    // border: 1.5px solid #06a9f4;
    color: white;
    height: 33px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    max-width: none;
    min-width: 0;
    padding: 0 13px;
    width: auto;

    &:not(:disabled) {
      cursor: pointer;
    }
  }
}

.ai-reedit-container {
  position: fixed;
}
</style>
<style lang="scss">
// Global tooltip styling for AI button (unscoped to work across components)
.tooltip.wt-preset-tooltip.-ai-reedit-tooltip {
  z-index: 9999;
  position: fixed;

  .tooltip-inner {
    font-size: 13px;
    padding: 10px 12px;
    max-width: 500px;
  }
}
</style>
